import { Link } from "react-router-dom";
import googleIcon from "@/assets/google-icon.png";

export default function GoogleReviewsButton() {
  return (
    <Link
      to="/reviews"
      aria-label="צפו בכל הביקורות שלנו ב-Google"
      className="fixed bottom-44 left-6 z-40 group"
    >
      <span className="absolute inset-0 rounded-full bg-white/40 blur-xl group-hover:bg-white/60 transition-colors" />
      <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-white shadow-lg ring-1 ring-black/5 hover:scale-110 transition-transform">
        <img
          src={googleIcon}
          alt="Google"
          width={32}
          height={32}
          decoding="async"
          className="h-8 w-8"
        />
      </span>
    </Link>
  );
}
